import styled from 'styled-components';

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 320px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
  z-index: 10;
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TooltipRow = styled.div`
  font-size: 14px;
  color: #666; 
  line-height: 1.4;

  strong {
    font-weight: 700;
    color: #333;
    margin-right: 4px; 
  }
`;
